import React, { useState, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Collapse from '@material-ui/core/Collapse';

import InvitationIcon from '@material-ui/icons/Drafts';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import SearchUsersAutocomplete from 'app/components/user/UserSearchAutocomplete';
import EditGuestDialog from 'app/components/event/EditGuestDialog';

import useApi from 'app/context/useApi';

const useStyles = makeStyles(theme => ({

    section: {
        padding: theme.spacing(3)
    },
    divider: {
        marginTop: theme.spacing(3)
    },
    marginTopSmall: {
        marginTop: theme.spacing(1),
    },
    marginTopReset: {
        marginTop: 0,
    },
    searchUserCon: {
        display: 'inline-block',
        minWidth: '240px',
        marginRight: theme.spacing(2)
    },
    menu: {
        width: '100%',
    },
    textButton: {
        marginLeft: theme.spacing(2),
        cursor: 'pointer'
    }
}));

const statusTypes = [
    {
        value: 'pending',
        label: 'Pending'
    },
    {
        value: 'maybe',
        label: 'Maybe'
    },
    {
        value: 'accepted',
        label: 'Accepted'
    },
    {
        value: 'declined',
        label: 'Declined'
    },
    {
        value: 'withdrawn',
        label: 'Withdrawn'
    },
]

const InvitationListItem = props => {

    const { invitation, handleChange, handleDelete, index, tickets, getErrorMessages } = props;

    const [ expanded, setExpanded ] = useState(false);

    const classes = useStyles();

    const handleExpand = () => {
        setExpanded(!expanded);
    }

    const errors = getErrorMessages(index);

    return (
        <ListItem divider>
            <ListItemAvatar>
                <Avatar>
                    <InvitationIcon />
                </Avatar>
            </ListItemAvatar>
            <ListItemText>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={4}>
                        {invitation.inviter ? (
                            <Fragment>
                                <Typography variant="subtitle2">
                                    <Typography component="span" variant="inherit">
                                        Inviter
                                    </Typography>
                                    <Typography
                                        component="span"
                                        color="primary"
                                        variant="inherit"
                                        className={classes.textButton}
                                        onClick={() => handleChange(index, 'inviter', null)}
                                        >
                                        Change
                                    </Typography>
                                </Typography>
                                <Typography variant="body2">
                                    {invitation.inviter.full_name}
                                </Typography>
                            </Fragment>
                        ) : (
                            <SearchUsersAutocomplete
                                groupType="all"
                                label="Select Inviter"
                                closeOnSelect
                                onSelect={(u) => handleChange(index, 'inviter', u)}
                            />
                        )}
                    </Grid>
                    <Grid item xs={3}>
                        {invitation.guest ? (
                            <Fragment>
                                <Typography variant="subtitle2">
                                    <Typography component="span" variant="inherit">
                                        Guest
                                    </Typography>
                                    <Typography
                                        component="span"
                                        color="primary"
                                        variant="inherit"
                                        className={classes.textButton}
                                        onClick={() => handleChange(index, 'guest', null)}
                                        >
                                        Change
                                    </Typography>
                                </Typography>
                                <Typography variant="body2">
                                    {invitation.guest.full_name}
                                </Typography>
                            </Fragment>
                        ) : (
                            <SearchUsersAutocomplete
                                groupType="all"
                                label="Select Guest"
                                closeOnSelect
                                onSelect={(u) => handleChange(index, 'guest', u)}
                            />
                        )}
                    </Grid>
                    {(tickets.length > 0) &&
                        <Grid item xs={3}>
                            <TextField
                                select
                                label="Ticket"
                                value={invitation.ticket_id}
                                onChange={(event) => handleChange(index, 'ticket_id', event.target.value)}
                                variant="outlined"
                                classes={{ root: classes.menu }}
                                >
                                <MenuItem value={''}>No Ticket Selected</MenuItem>
                                {tickets.map(t => (
                                    <MenuItem key={t.id} value={t.id}>{t.title}</MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                    }
                    <Grid item xs={2}>
                        <div className="tr">
                            <IconButton onClick={handleExpand}>
                                {expanded ? (
                                    <ExpandLessIcon/>
                                ) : (
                                    <ExpandMoreIcon/>
                                )}

                            </IconButton>
                            <IconButton onClick={() => handleDelete(index)}>
                                <DeleteIcon/>
                            </IconButton>
                        </div>
                    </Grid>
                </Grid>
                <Collapse in={expanded}>
                    <Grid container spacing={3} alignItems="flex-start" className={classes.marginTopSmall}>
                        <Grid item xs={4}>
                            <TextField
                                label="Title"
                                value={invitation.title}
                                onChange={(event) => handleChange(index, 'title', event.target.value)}
                                variant="outlined"
                                fullWidth
                            />
                            <TextField
                                label="Message"
                                multiline
                                value={invitation.message}
                                onChange={(event) => handleChange(index, 'message', event.target.value)}
                                variant="outlined"
                                fullWidth
                                className={classes.divider}
                            />
                            
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                label="Invitation Details"
                                multiline
                                value={invitation.details}
                                onChange={(event) => handleChange(index, 'details', event.target.value)}
                                variant="outlined"
                                fullWidth
                            />
                            <TextField
                                label="Date Name"
                                value={invitation.dateName}
                                onChange={(event) => handleChange(index, 'dateName', event.target.value)}
                                variant="outlined"
                                fullWidth
                                className={classes.divider}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                select
                                label="Status"
                                value={invitation.status}
                                onChange={(event) => handleChange(index, 'status', event.target.value)}
                                variant="outlined"
                                classes={{ root: classes.menu }}
                                >
                                {statusTypes.map(s => (
                                    <MenuItem key={s.value} value={s.value}>{s.label}</MenuItem>
                                ))}
                            </TextField>
                            <TextField
                                select
                                label="Paid"
                                value={invitation.paid}
                                onChange={(event) => handleChange(index, 'paid', event.target.value)}
                                variant="outlined"
                                className={classes.divider}
                                classes={{ root: classes.menu }}
                                >
                                <MenuItem value="yes">Yes</MenuItem>
                                <MenuItem value="no">No</MenuItem>
                            </TextField>
                            <FormControlLabel
                                className={classes.marginTopSmall}
                                control={
                                    <Checkbox
                                        color="primary"
                                        checked={invitation.email_invitation}
                                        onChange={
                                            (event) => handleChange(index, 'email_invitation', event.target.checked)
                                        }
                                        value="email_invitation"
                                    />
                                }
                                label="Email Invite?"
                            />
                        </Grid>
                    </Grid>
                </Collapse>
                {(errors.length > 0) &&
                    <Typography color="error" variant="subtitle2" className={classes.divider}>
                        <ul>
                            {errors.map((error, key) => (
                                <li key={key}>{error}</li>
                            ))}
                        </ul>
                    </Typography>
                }
            </ListItemText>
        </ListItem>
    )
}

export default function BulkInvitations(props) {

    const { event, tickets, setLoading, loading } = props;

    const history = useHistory();
    const api = useApi();
    const classes = useStyles();

    const [ invitations, setInvitations ] = useState([]);

    const [ guestDialogOpen, setGuestDialogOpen ] = useState(false);
    const [ editingUser, setEditingUser ] = useState(null);

    const [ errors, setErrors ] = useState([]);

    // Setter Functions ------------------------------------------

    const handleListItem = (i, field, value) => {
        const newInvitations = [...invitations];
        newInvitations[i][field] = value;
        console.log(newInvitations);
        setInvitations(newInvitations);
    }

    const deleteListItem = i => {
        const newInvitations = [...invitations];
        newInvitations.splice(i, 1);
        setInvitations(newInvitations);
    }

    // Post Functions ------------------------------------------

    const postInvitations = () => {
        if (invitations.length > 0) {
            setLoading(true);

            api.post('/admin/invitation/bulk', {invitations: invitations, event_id: event.id})
                .then(() => {
                    history.push('/admin/events/' + event.id + '/invitations');
                }).catch( error => {
                    if (error?.response?.data?.errors) {
                        setErrors(error.response.data.errors)
                    }
                }).finally(() => setLoading(false));
        }
    }

    console.log(errors);

    // General Functions ------------------------------------------

    const createNewListItem = () => {
        const l = invitations.length
        const i = l - 1;
        let newItem;

        if (l) {
            newItem = {...invitations[i], guest: null, dateName: "" }
        } else {
            newItem = {
                event_id: event.id,
                inviter: null,
                guest: null,
                ticket_id: '',
                title: "You have been invited to " + event.name,
                message: "I would like to invite you as my guest to " + event.name + ". Thank you for your consideration!",
                email_invitation: false,
                status: 'pending',
                paid: 'no',
                dateName: "",
                details: ""
            }
        }

        setInvitations([...invitations, newItem ]);

    }

    // Error Functions ------------------------------------------

    const hasErrors = key => {
        if (errors[key]) return true;
        return false;
    }

    const getErrorMessages = key => {
        if (hasErrors(key)) return errors[key];
        return "";
    }

    // Editing User Dialog Functions ///////////////////////////////////////////////////////////////

    const openGuestDialog = (u = null) => {
        if (u) setEditingUser(u);
        setGuestDialogOpen(true)
    }

    const closeGuestDialog = () => {
        setGuestDialogOpen(false);
    }

    const guestDialogClosed = () => {
        setEditingUser(null);
    }

    // Rendering Functions ------------------------------------------

    return (
        <form noValidate autoComplete="off" className={classes.section}>
            <Grid
                container
                alignItems="center"
                justify="space-between"
                spacing={3}
                >
                <Grid item>
                    <Typography variant="h6" component="h3">
                        Bulk Invitation Upload
                    </Typography>
                </Grid>
                <Grid item>
                    <Button
                        variant="outlined"
                        startIcon={<AddIcon />}
                        onClick={openGuestDialog}
                        color="primary"
                        >
                        New Guest
                    </Button>
                </Grid>
            </Grid>
            <Divider className={classes.divider}/>
            <List dividers>
                {invitations.map((i, key) => (
                    <InvitationListItem
                        key={key}
                        invitation={i}
                        index={key}
                        handleChange={handleListItem}
                        handleDelete={deleteListItem}
                        tickets={tickets}
                        hasErrors={hasErrors}
                        getErrorMessages={getErrorMessages}
                    />
                ))}
            </List>
            <Grid
                container
                justify="space-between"
                alignItems="center"
                spacing={3}
                className={classes.marginTopReset}
                >
                <Grid item>
                    <Button
                        variant="outlined"
                        startIcon={<AddIcon />}
                        onClick={createNewListItem}
                        color="primary"
                        >
                        New Invitation
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        variant="contained"
                        onClick={postInvitations}
                        color="primary"
                        disabled={!invitations.length || loading}
                        >
                        Save Invitations
                    </Button>
                </Grid>
            </Grid>
            <EditGuestDialog
                open={guestDialogOpen}
                guest={editingUser}
                onClose={closeGuestDialog}
                onSave={closeGuestDialog}
                onDelete={closeGuestDialog}
                onClosed={guestDialogClosed}
                eventID={event.id}
            />
        </form>
    );
}
